import BigNumber from "bignumber.js";
export function serializeCardanoTransaction({ amount, family, fees, memo, mode, recipient, }) {
    return {
        amount: amount.toString(),
        family,
        fees: fees ? fees.toString() : undefined,
        memo,
        mode,
        recipient,
    };
}
export function deserializeCardanoTransaction({ amount, family, fees, memo, mode, recipient, }) {
    return {
        amount: new BigNumber(amount),
        family,
        fees: fees ? new BigNumber(fees) : undefined,
        memo,
        mode,
        recipient,
    };
}
//# sourceMappingURL=serializer.js.map